<template>
  <div class="ui-content dashboard">
    <div v-if="step == 1" class="full-size-block">
      <v-card
        class="mx-auto normal-card autohg create-test-cust cust-test-create"
      >
        <div class="add-user-form-test cust-test-blk">
          <PatternI :data="stepOneData" :onNextClick="onNextClick" />
        </div>
      </v-card>
    </div>
    <div v-if="step == 2" class="full-size-block step-2">
      <v-card
        class="mx-auto normal-card autohg create-test-cust cust-test-create"
      >
        <div v-if="step == 2" class="add-user-form-test cust-test-blk">
          <PatternII
            :data="stepTwoData"
            :stepOneData="stepOneData"
            :onBackClick="onBackClick"
            :onCustomizeClick="onCustomizeClick"
          />
        </div>
      </v-card>
    </div>
    <div v-if="step == 3" class="full-size-block">
      <PatternIII
        :data="stepThreeData"
        :stepOneData="stepOneData"
        :stepTwoData="stepTwoData"
        :onBackClick="onBackClick"
        :onCustomizeClick="onCustomizeClick"
      />
    </div>
  </div>
</template>

<script>
import PatternI from "@/components/coordinator/Tests/CustomizedTests/PatternI.vue";
import PatternII from "@/components/coordinator/Tests/CustomizedTests/PatternII.vue";
import PatternIII from "@/components/coordinator/Tests/CustomizedTests/PatternIII.vue";
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  name: "CustomizedTests",
  components: {
    PatternI,
    PatternII,
    PatternIII,
  },
  computed: {
    ...mapState("userStore", ["user"]),
  },
  mounted() {
    this.addBreadCrumbChilde([
      {
        text: "Create New test",
        disabled: false,
      },
      {
        text: "Test Pattern Details",
        disabled: false,
      },
    ]);
    this.requestGetRefData();
  },
  beforeDestroy() {
    this.addBreadCrumbChilde([]);
  },
  data() {
    return {
      step: 1,
      stepOneData: null,
      stepTwoData: null,
      stepThreeData: null,
      questionTypes: [],
    };
  },

  methods: {
    ...mapMutations("app", ["addBreadCrumbChilde"]),
    ...mapActions({
      getRefData: "utilStore/getRefData",
      getTestList: "testStore/getTestList",
      me: "userStore/me",
    }),
    onNextClick(data) {
      if (this.validate(data)) {
        if (data.lastStep) {
          this.stepOneData = data;
          this.stepOneData.selectedSubjects.map((s, i) => (s.sortBy = i));
          this.onCustomizeClick(data);
        } else {
          this.stepOneData = data;
          this.step = this.step + 1;
          this.stepOneData.selectedSubjects.map((s, i) => (s.sortBy = i));
          this.addBreadCrumbChilde([
            {
              text: "Create New test",
              disabled: false,
            },
            {
              text: "Test Pattern Details",
              class: "cursor-pointer",
              disabled: false,
              click: () => {
                this.step = 1;
                this.addBreadCrumbChilde([
                  {
                    text: "Create New test",
                    disabled: false,
                  },
                  {
                    text: "Test Pattern Details",
                    disabled: false,
                  },
                ]);
              },
            },
            {
              text: "Customize Pattern",
              disabled: false,
            },
          ]);
        }
      }
    },
    onBackClick(data) {
      this.addBreadCrumbChilde([
        {
          text: "Create New test",
          disabled: false,
        },
        {
          text: "Test Pattern Details",
          disabled: false,
        },
      ]);
      this.stepTwoData = data;
      this.step = this.step - 1;
    },
    validate(data) {
      const checkDifficulty =
        JSON.parse(localStorage.getItem("dummyQuestionTest")) === true;
      if (!data || !data.testName || data.testName.trim().length === 0) {
        this.$toasted.error(`Please enter test name`, { icon: "info" });
        return false;
      } else if (data && data.testName.trim().length > 50) {
        this.$toasted.error(
          `Test Name should not contain more than 50 characters`,
          { icon: "info" }
        );
        return false;
      } else if (!data.duration || data.duration < 1) {
        this.$toasted.error(`Please enter duration`, { icon: "info" });
        return false;
      } else if (!data.selectedTarget || data.selectedTarget.length === 0) {
        this.$toasted.error(`Please select exam target`, {
          icon: "info",
        });
        return false;
      } else if (!data.selectedPatterns) {
        this.$toasted.error(`Please select exam pattern`, {
          icon: "info",
        });
        return false;
      } else if (!data.selectedClasses) {
        this.$toasted.error(`Please select data type`, { icon: "info" });
        return false;
      } else if (!data.selectedSubjects || data.selectedSubjects.length === 0) {
        this.$toasted.error(`Please select subject`, { icon: "info" });
        return false;
      } else if (
        checkDifficulty &&
        data.selectedSubjects &&
        data.selectedSubjects.length
      ) {
        let valid = true;
        let subjectDifficulty = [],
          subjectDiff100 = [];
        data.selectedSubjects.map((s) => {
          if (!(s.easy || s.moderate || s.tough)) {
            subjectDifficulty.push(s.title);
            valid = false;
          }
          let total = s.easy + s.moderate + s.tough;
          if (total != 100 && !subjectDifficulty.includes(s.title)) {
            subjectDiff100.push(s.title);
            valid = false;
          }
        });
        if (subjectDifficulty && subjectDifficulty.length) {
          this.$toasted.error(
            `Please select difficulty level for ${subjectDifficulty.join(
              ", "
            )}`,
            {
              icon: "info",
            }
          );
        }
        if (subjectDiff100 && subjectDiff100.length) {
          this.$toasted.error(
            `Please check sum for ${subjectDiff100.join(
              ", "
            )} should be equal to 100%`,
            {
              icon: "info",
            }
          );
        }

        if (!valid) {
          return false;
        }
      }
      return true;
    },
    onCustomizeClick(data) {
      this.step = data.lastStep ? this.step + 2 : this.step + 1;
      let breacrumb = [
        {
          text: "Create New test",
          disabled: false,
        },
        {
          text: "Test Pattern Details",
          class: "cursor-pointer",
          disabled: false,
          click: () => {
            this.step = 1;
            this.addBreadCrumbChilde([
              {
                text: "Create New test",
                disabled: false,
              },
              {
                text: "Test Pattern Details",
                disabled: false,
              },
            ]);
          },
        },
        {
          text: "Customize Pattern",
          class: "cursor-pointer",
          disabled: false,
          click: () => {
            this.step = 2;
            this.addBreadCrumbChilde([
              {
                text: "Create New test",
                disabled: false,
              },
              {
                text: "Test Pattern Details",
                disabled: false,
                class: "cursor-pointer",

                click: () => {
                  this.step = 1;
                  this.addBreadCrumbChilde([
                    {
                      text: "Create New test",
                      disabled: false,
                    },
                    {
                      text: "Test Pattern Details",
                      disabled: false,
                    },
                  ]);
                },
              },
              {
                text: "Customize Pattern",
                disabled: false,
                click: () => {
                  this.step = 1;
                  this.addBreadCrumbChilde([
                    {
                      text: "Create New test",
                      disabled: false,
                    },
                    {
                      text: "Test Pattern Details",
                      class: "cursor-pointer",
                      disabled: false,
                      click: () => {
                        this.step = 1;
                        this.addBreadCrumbChilde([
                          {
                            text: "Create New test",
                            disabled: false,
                          },
                          {
                            text: "Test Pattern Details",
                            disabled: false,
                          },
                        ]);
                      },
                    },
                    {
                      text: "Customize Pattern",
                      disabled: false,
                    },
                  ]);
                },
              },
            ]);
          },
        },
        {
          text: "Customized Syllabus",
          disabled: false,
        },
      ];
      this.stepTwoData = data;
      if (data.lastStep) {
        breacrumb = [
          {
            text: "Create New test",
            disabled: false,
          },
          {
            text: "Test Pattern Details",
            class: "cursor-pointer",
            disabled: false,
            click: () => {
              this.step = 1;
              this.addBreadCrumbChilde([
                {
                  text: "Create New test",
                  disabled: false,
                },
                {
                  text: "Test Pattern Details",
                  disabled: false,
                },
              ]);
            },
          },
          {
            text: "Customized Syllabus",
            disabled: false,
          },
        ];
        this.stepTwoData.instructions = data?.instructions || "";
        this.stepTwoData.questionTypes = this.questionTypes;
      }
      this.addBreadCrumbChilde(breacrumb);
    },
    requestGetRefData() {
      let reqData = { keys: ["QUESTION_TYPE"] };
      this.getRefData(reqData)
        .then((response) => {
          this.loading = false;
          this.questionTypes = response.QUESTION_TYPE.map((x) => {
            let c = {};
            c.text = x.value;
            c.value = { id: x.id, title: x.value };
            c.checked = false;
            return c;
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>
